module.exports = __webpack_public_path__ + "img/go_reco.4d5ca109.svg";